var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "80 200 1460 1200",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        { attrs: { transform: "matrix(-1.80625 0 0 1.80667 1516 68)" } },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_1_", d: "M-322.5-242h1445V842h-1445z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_1_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_2_)" } },
            [
              _c("path", {
                staticStyle: { fill: "#e6e6e6" },
                attrs: {
                  d: "m672.9 476.9 12.2-3.8c1-.7 2.1-1.1 3.1-2l-19 6.1c1.3 0 2.5 0 3.7-.3zm-8.6 0 27.6-9c.5-.4.9-1 1.4-1.4l-30.9 9.8c.6.4 1.3.5 1.9.6zm-4.9-1.2 36.1-11.6c.4-.3.5-.8 1-1.2L658.4 475c.4.5.7.5 1 .7zm-2.8-1.8 41.5-13.3c.2-.3.4-.8.7-1.1L656 473.2c.1.4.4.6.6.7zm-2.1-2.1 45.2-14.4c.2-.3.2-.7.4-1.1L654 471.2c.3.2.4.5.5.6zm-1.3-2.2 48-15.3c0-.3.2-.7.2-1.1l-48.7 15.6c.2.3.3.6.5.8zm-1.2-2.4 49.9-16c0-.3.1-.7.2-1.1l-50.4 16c.1.6.2.8.3 1.1zm-.8-2.4 51.4-16.5c0-.3.1-.7.1-1L650.8 464c.1.2.2.5.4.8zm-.5-2.9c.1.1-.1.2 0 .3l52.3-16.7c0-.3.1-.7.1-1L651 461.1c-.1.2-.2.5-.3.8zm2.7-3.7c-.1.1-.2.3-.4.3l50.1-16c0-.3-.1-.5 0-.9l-48.8 15.7c-.4.3-.6.7-.9.9zm2.4-3.2 46.8-15c0-.3-.1-.5-.2-.9L656.3 454c0 .3-.2.6-.5 1zm1.6-3.3 45.1-14.4c-.1-.3-.1-.5-.2-.9l-44.4 14.3c-.4.5-.4.8-.5 1zm.7-2.9 43.7-13.9c-.1-.3-.2-.4-.2-.9l-43.1 13.9c-.3.3-.4.6-.4.9zm.3-2.9 42.5-13.5c-.1-.3-.2-.4-.3-.8L658.4 445v.9zm-.3-2.7 41.3-13.2c-.1-.3-.2-.4-.3-.8l-41 13.1v.9zm-.5-2.5 40.3-13c-.1-.3-.4-.5-.5-.7l-40.2 12.9.4.8zm37.8-15.7-39.2 12.4c.1.3.2.4.3.8l39.5-12.7c0-.1-.3-.3-.6-.5zm-2.3-2-38.2 12.2c.1.3.4.5.5.7l38.5-12.3c-.3 0-.6-.4-.8-.6zm-3.1-1.7-36.5 11.6c.1.3.2.4.3.8l37.2-12c-.3-.1-.5-.3-1-.4zm-3.8-1.4c-.1.1-.2-.1-.3 0l-32.2 10.3c-.1.2-.1.7-.1 1l34.1-10.9c-.6-.1-1.1-.3-1.5-.4zm-8.2-.4-20.9 6.7-2.1 1.5 26.4-8.4c-1 .1-2.3.1-3.4.2z",
                },
              }),
              _c("path", {
                staticClass: "st2",
                attrs: {
                  d: "M734.7 291.8c1.5 4.6-.2 9.5-2.5 13.8-6.2 11.7-16.3 21.3-28.3 26.9-6.7 3.2-13.9 5-20.7 7.9-20 8.3-36.2 24.9-44 45.1 2.3-14-5-27.8-14-38.9-8.8-11-19.5-21-25.9-33.6-5.5-10.9-5.6-27.1 5.5-32.3 8.1-3.8 18.2.4 26.5-3.1 2.9-1.3 5.6-3.9 5.5-7.1-.4-8.1-16.4-7.5-16.8-15.6-.4-9.3 24-6.5 20.9-15.4-1.3-3.7-6.5-4.8-8.3-8.3-1.9-3.5-1.7-8.4 1.4-10.9 4-3.3 10.2-.7 15.3-1.9 5.8-1.3 9.5-7.2 10.7-13.1s.5-11.9 1.4-17.8c2.1-14.5 14-27.1 28.3-30.1 14.3-3.1 30.2 3.7 38 16.2 3.2 5.1 4.9 12 1.5 16.9-2.9 4.1-9.3 6.9-8.7 11.9.7 6.9 13.4 7.5 13.6 14.4.2 8.1-16.4 8.1-15.9 16.2.2 3.6 4 5.7 6.3 8.5 4.4 5.2 2.6 14.3-3.4 17.6-2.4 1.3-5.2 1.9-7.1 3.7-4.8 4.7-.1 13 5.6 16.5 5.6 3.3 13 6.1 15.1 12.5z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_3_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-2132.744",
                    y1: "1989.881",
                    x2: "-676.898",
                    y2: "1989.881",
                    gradientTransform:
                      "matrix(-.1806 0 0 .1807 256.181 -55.99)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#e9f1fe" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_3_)" },
                attrs: {
                  d: "M692.7 292.3c3.4-1.9 7-3.6 9.7-6.4 5.6-6.1 5.2-15.3 5.7-23.6s3.4-18 11.4-20.2c6.7-1.9 15.1 2.2 20-2.6 1.9-1.7 2.6-4.4 3.9-6.6 5.7-9.5 20.6-8.7 28.9-1.4 8.2 7.3 11.4 18.7 14.1 29.4 1 3.9 1.1 9.4-2.7 10.5-3.7 1-7.4-3.6-10.9-2.2-2.8 1.1-3.1 5.1-2 8.1 1 2.8 2.7 5.8 2.1 8.8-1.3 5.7-9.3 6-15 4.5-5.7-1.5-13-3.1-16.3 1.9 3.6 11.5 6.7 25.4-1.4 34.5-9.3 10.4-26.4 9.3-40.3 10.6-25.8 2.4-44 22.1-58.5 43.6-.8-36.1 19.8-71.7 51.3-88.9z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "M660.4 364.7h-.2c-.3-.1-.4-.4-.3-.7 13.1-40.1 34-67.9 72.1-96 7.1-5.2 28.5-14.1 37.8-14.8.2 0 .5.2.5.5s-.2.5-.5.5c-8.8.8-30.3 9.6-37.1 14.6-38 27.9-58.7 55.6-71.7 95.4-.1.3-.4.5-.6.5zM680.6 247.3l-4.4-12c-1.5-.1-3.2.1-4.7.7l4.7 12.9c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-4.7-12.7c-1.4.9-2.6 2.1-3.6 3.4l3.9 10.7c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-3.1-8.4c-1.7 4.4-1.9 9.9.1 15.4 0 .1.1.2.1.3-1 .5-2.1 1.2-2.9 2-2.7 2-6.2 5.3-7.4 10.2l1.3.3c1.1-4.4 4.4-7.5 6.9-9.3.9-.7 1.7-1.2 2.7-1.7 2.1 4.6 5.5 8.3 9.2 10.3l-2.9-8c-.2-.8.1-1.5.9-1.7s1.5.1 1.7.9l3.8 10.3c1.6.4 3.3.5 4.9.2l-4.4-12c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l4.5 12.1c1.4-.7 2.7-1.6 3.8-2.7l-4-10.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l3.5 9.4c1.1-1.6 2.1-3.4 2.9-5.2l-2.2-5.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l1.2 3.2c2.2-5.2 3.6-10.4 5.5-12-3.1-.7-7.3-3.5-12-6.1l1.5 4c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-2.5-6.9c-1.9-.9-3.7-1.5-5.6-2l3.8 10.6c.2.8-.1 1.5-.9 1.7-.5-.1-1.2-.4-1.6-1.1z",
                },
              }),
              _c("path", {
                staticStyle: { fill: "#d6d7d8" },
                attrs: { d: "M342.9 516.5h121.8V381H342.9z" },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: { d: "M267.4 522.6h272.7v-10.5H267.4z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_4_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "664.301",
                    y1: "1943.732",
                    x2: "6015.851",
                    y2: "1943.732",
                    gradientTransform:
                      "matrix(-.1806 0 0 .1807 256.181 -55.99)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#eee" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#d6d7d8" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_4_)" },
                attrs: { d: "M136.2 468.4h535.2V121.9H136.2z" },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: { d: "M145.6 415.9H662V130.5H145.6z" },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: {
                  transform: "rotate(-45.009 384.56 442.708)",
                  d: "M379.6 447.7h9.9v-9.9h-9.9z",
                },
              }),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  transform: "rotate(-45.009 403.722 442.694)",
                  d: "M398.8 447.7h9.9v-9.9h-9.9z",
                },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: {
                  transform: "rotate(-45.009 422.884 442.724)",
                  d: "M417.9 447.7h9.9v-9.9h-9.9z",
                },
              }),
              _c("g", [
                _c("path", {
                  staticClass: "st2",
                  attrs: {
                    d: "M61.4 450.3c-.2 4.8 2.7 9.2 6.1 12.7 9.2 9.7 21.5 16.4 34.6 18.6 7.3 1.2 14.8 1.2 22.3 2.1 21.6 2.7 41.8 14.5 54.8 32-6-13-2.5-28.4 3.2-41.5 5.7-13.1 13.4-25.5 16.2-39.5 2.4-12-1.9-27.8-14-29.9-9-1.5-17.7 5.3-26.6 4-3.2-.4-6.6-2.3-7.2-5.5-1.7-8 14-11.7 12.1-19.7-2.1-9.2-25.1 0-24.3-9.3.3-3.9 5-6.3 5.9-10.3s-.5-8.6-4.3-10.2c-4.8-2.1-10 2.1-15.3 2.3-6 .3-11.1-4.5-13.9-9.8s-3.7-11.5-6.1-16.9c-5.9-13.5-20.7-22.6-35.5-21.7-14.7.9-28.4 11.7-32.6 25.9-1.7 5.8-1.6 13 3.1 16.9 3.9 3.3 10.8 4.1 11.7 9.2 1.2 6.9-11 10.9-9.4 17.7 1.9 8 18.1 3.5 19.8 11.5.8 3.6-2.4 6.7-3.8 9.9-2.8 6.2 1.3 14.5 8 16.2 2.6.7 5.6.3 8 1.6 5.9 3.3 3.6 12.6-1 17.5-5 5-11.4 9.4-11.8 16.2z",
                  },
                }),
                _c("path", {
                  staticClass: "st9",
                  attrs: { d: "M178.9 517.2c-8.7-22.8-15.7-46.3-21.1-70.1" },
                }),
                _c("ellipse", {
                  staticClass: "st10",
                  attrs: {
                    transform: "rotate(-77.079 157.612 444.734)",
                    cx: "157.6",
                    cy: "444.7",
                    rx: "4.7",
                  },
                }),
                _c("path", {
                  staticClass: "st9",
                  attrs: { d: "M157.2 444.3c-2.9-13.5-5.3-27.1-7.2-40.8" },
                }),
                _c("ellipse", {
                  staticClass: "st10",
                  attrs: {
                    transform: "rotate(-71.489 149.502 400.297)",
                    cx: "149.5",
                    cy: "400.3",
                    rx: "5.6",
                  },
                }),
                _c("path", {
                  staticClass: "st9",
                  attrs: { d: "M149.4 399.9c-1.4-11.4-2.5-22.7-3.3-34.1" },
                }),
                _c("ellipse", {
                  staticClass: "st10",
                  attrs: {
                    transform:
                      "matrix(.0106 -.9999 .9999 .0106 -216.549 504.914)",
                    cx: "146.9",
                    cy: "361.9",
                    rx: "5.6",
                  },
                }),
                _c("path", {
                  staticClass: "st9",
                  attrs: { d: "M145.9 361c-.4-8.6-.7-17.4-.8-26.1" },
                }),
                _c("ellipse", {
                  staticClass: "st10",
                  attrs: {
                    transform:
                      "matrix(.0106 -.9999 .9999 .0106 -186.728 472.17)",
                    cx: "145.2",
                    cy: "330.4",
                    rx: "7.5",
                  },
                }),
                _c("path", {
                  staticClass: "st9",
                  attrs: { d: "M145.1 329c.1-5.8.2-11.6.4-17.4" },
                }),
              ]),
              _c("path", {
                staticClass: "st4",
                attrs: {
                  d: "m132.8 484.9 4.4-12c1.5-.1 3.2.1 4.7.7l-4.7 12.9c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l4.7-12.7c1.4.9 2.6 2.1 3.6 3.4l-3.9 10.7c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l3.1-8.4c1.7 4.4 1.9 9.9-.1 15.4 0 .1-.1.2-.1.3 1 .5 2.1 1.2 2.9 2 2.7 2 6.2 5.3 7.4 10.2l-1.3.3c-1.1-4.4-4.4-7.5-6.9-9.3-.9-.7-1.7-1.2-2.7-1.7-2.1 4.6-5.5 8.3-9.2 10.3l2.9-8c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.8 10.3c-1.6.4-3.3.5-4.9.2l4.4-12c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-4.5 12.1c-1.4-.7-2.7-1.6-3.8-2.7l4-10.9c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.5 9.4c-1.1-1.6-2.1-3.4-2.9-5.2l2.2-5.9c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-1.2 3.2c-2.2-5.2-3.6-10.4-5.5-12 3.1-.7 7.3-3.5 12-6.1l-1.5 4c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l2.5-6.9c1.9-.9 3.7-1.5 5.6-2l-3.8 10.6c-.2.8.1 1.5.9 1.7.5 0 1.3-.3 1.6-1.1z",
                },
              }),
              _c("path", {
                staticStyle: { fill: "#b3c9ee" },
                attrs: {
                  d: "m687.1 497.3 12.8.5c1.2-.2 2.4-.3 3.5-.8l-20-.7c1.4.3 2.5.7 3.7 1zm-8.1-3 29 1c.7-.2 1.1-.5 1.9-.9l-32.4-1.2c.5.6.9.9 1.5 1.1zm-4-2.7 37.9 1.3c.5-.2.8-.5 1.3-.8l-40-1.5c.2.5.5.6.8 1zm-2.2-2.8 43.6 1.5c.3-.2.7-.5 1-.8l-44.9-1.6c-.1.5.2.8.3.9zm-1.2-2.6 47.5 1.7c.3-.2.4-.5.8-.9l-48.5-1.7c.2.4.2.7.2.9zm-.6-2.5 50.3 1.9c.1-.3.4-.5.7-.9l-51.1-1.9c.1.3.1.6.1.9zm-.2-2.7 52.4 2c.1-.3.3-.5.7-.9L671 480c-.2.5-.2.7-.2 1zm0-2.5 53.9 2c.1-.3.3-.5.4-.9l-54.5-2c.2.2.2.5.2.9zm.7-3c0 .2-.1.2-.1.3l54.8 2.1c.1-.3.3-.5.4-.9l-54.6-2c-.2.2-.4.3-.5.5zm3.7-2.5c-.2 0-.3.2-.5.2l52.6 1.9c.1-.3.1-.5.3-.9l-51.2-1.9c-.6.3-.9.5-1.2.7zm3.4-2.2 49.1 1.9c.1-.3.1-.5.1-.9l-48.5-1.7c-.1.2-.4.4-.7.7zm2.5-2.5 47.3 1.7c0-.3.1-.5.1-.9l-46.6-1.6c-.5.3-.6.6-.8.8zm1.7-2.5 45.7 1.7c0-.3 0-.5.1-.9l-45.2-1.6c-.4.3-.5.5-.6.8zm1.1-2.6 44.5 1.6c0-.3 0-.5-.1-.9l-44.2-1.7c.1.4 0 .8-.2 1zm.9-2.6 43.3 1.6c0-.3 0-.5-.1-.9l-43-1.6c-.1.3-.2.7-.2.9zm.3-2.6 42.4 1.5c0-.3-.2-.7-.2-.9l-42.1-1.5c-.2.3-.1.6-.1.9zm40.8-2-41.2-1.6c0 .3 0 .5.1.9l41.5 1.5c.1-.2-.1-.5-.4-.8zm-1.5-2.6-40.1-1.5c0 .3.2.7.2.9l40.5 1.5c-.3-.3-.4-.6-.6-.9zm-2.3-2.8-38.2-1.5c0 .3 0 .5.1.9l39.1 1.4c-.4-.1-.7-.4-1-.8zm-3-2.6c-.2 0-.2-.1-.3-.1l-33.8-1.3c-.1.2-.3.5-.4.9l35.7 1.3c-.6-.1-.9-.5-1.2-.8zm-7.6-2.9-21.8-.9c-.9.2-1.6.4-2.5.7l27.6 1.1c-1.1-.3-2.3-.7-3.3-.9z",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("g", { attrs: { transform: "matrix(5.57567 0 0 5.5768 172 613)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_5_", d: "M-134.6-134.6h328v328h-328z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_6_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_5_" },
          }),
        ]),
        _c(
          "g",
          {
            staticStyle: { "clip-path": "url(#SVGID_6_)" },
            attrs: { transform: "translate(2186.766 -352.498)" },
          },
          [
            _c("path", {
              staticClass: "st6",
              attrs: {
                d: "M-2132.7 372.2c-.2-.4-.4-.9-.5-1.3l2.3-2.1c-.8-1.6-1.7-3.1-2.8-4.5l-2.9 1.2c-.8-1-1.6-1.9-2.6-2.8l1.3-2.8c-1.4-1.3-3-2.4-4.7-3.4l-2.2 2.2c-1.1-.6-2.3-1.1-3.5-1.6l.1-3.1c-1.7-.6-3.4-1-5.1-1.2l-1.2 2.9c-1.3-.1-2.5-.2-3.8-.2l-1-2.9c-1.9.1-3.8.4-5.7.9v3.1c-.8.2-1.5.5-2.3.8-.4.2-.9.4-1.3.5l-2.1-2.3c-1.6.8-3.1 1.7-4.5 2.8l1.2 2.9c-1 .8-1.9 1.6-2.8 2.6l-2.8-1.3c-1.3 1.5-2.4 3-3.4 4.7l2.2 2.2c-.6 1.1-1.1 2.3-1.6 3.5l-3.1-.1c-.6 1.7-1 3.4-1.2 5.1l2.9 1.2c-.1 1.3-.2 2.5-.2 3.8l-2.9 1c.1 1.9.4 3.8.9 5.7h3.1c.2.8.5 1.5.8 2.3.2.4.4.9.5 1.3l-2.3 2.1c.8 1.6 1.7 3.1 2.8 4.5l2.9-1.2c.8 1 1.6 1.9 2.6 2.8l-1.3 2.8c1.4 1.3 3 2.4 4.7 3.4l2.2-2.2c1.1.6 2.3 1.1 3.5 1.6l-.1 3.1c1.7.6 3.4 1 5.1 1.2l1.2-2.9c1.3.1 2.5.2 3.8.2l1 2.9c1.9-.1 3.8-.4 5.7-.9v-3.1c.8-.2 1.5-.5 2.3-.8.4-.2.9-.4 1.3-.5l2.1 2.3c1.6-.8 3.1-1.7 4.5-2.8l-1.2-2.9c1-.8 1.9-1.6 2.8-2.6l2.8 1.3c1.3-1.5 2.4-3 3.4-4.7l-2.2-2.2c.6-1.1 1.1-2.3 1.6-3.5l3.1.1c.6-1.7 1-3.4 1.2-5.1l-2.9-1.2c.1-1.3.2-2.5.2-3.8l2.9-1c-.1-1.9-.4-3.8-.9-5.7h-3.1c-.3-.8-.5-1.5-.8-2.3z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                d: "M-2147.9 376.6c-1.1-2.1-.9-4.5.3-6.3-3.3-2.8-7.7-4-12-3.4.1 2.2-1 4.4-3.1 5.5-2.1 1.1-4.5.9-6.4-.3-2.8 3.3-4 7.7-3.4 12 2.2-.1 4.4 1 5.5 3.1 1.1 2.1.9 4.5-.3 6.3 3.3 2.8 7.7 4 12 3.4-.1-2.2 1-4.4 3.1-5.5 2.1-1.1 4.5-.9 6.4.3 2.8-3.3 4-7.7 3.4-12-2.1.2-4.3-1-5.5-3.1zm-6.5 10.6c-2.9 1.6-6.7.6-8.3-2.4-1.6-3-.6-6.7 2.4-8.3 2.9-1.6 6.7-.6 8.3 2.4 1.6 3 .6 6.7-2.4 8.3z",
              },
            }),
          ]
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(1.39623 0 0 1.398 287 395)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_7_", d: "M-63-99.5h444v699H-63z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_8_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_7_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_8_)" } }, [
          _c("g", { attrs: { id: "woman-i2" } }, [
            _c("g", { attrs: { id: "shoes-i2" } }, [
              _c("path", {
                staticClass: "st6",
                attrs: {
                  id: "L_shoe_2_-i2",
                  d: "m166.5 440.8 17.4 22.6-60.8 36.6s-4.1-4.9 1.5-12.1c5.7-7.2 16.7-32.7 16.7-32.7l25.2-14.4z",
                },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: {
                  id: "R_shoe_2_-i2",
                  d: "m269.5 283.4 26.7-11.7 21.8 67.4s-5.7 2.9-11.4-4.2-30-23.8-30-23.8l-7.1-27.7z",
                },
              }),
            ]),
            _c("g", { attrs: { id: "trousers_1_-i2" } }, [
              _c("g", { attrs: { id: "L_trousers_1_-i2" } }, [
                _c("path", {
                  staticStyle: { fill: "#eee" },
                  attrs: {
                    id: "L_trousers_2_-i2",
                    d: "m166.5 440.8-25.1 14.5s-38.8-97.8-40.7-117.5c-1.9-19.8-.4-43.4 2.3-62.8 2.7-19.4 7.6-35.8 3.8-53.2l.7-.1c13.9 1.9 32.5-2.3 40.7-4.5 1.7-.5 3.5-.8 5.2-.9 1.4 2.2 11.4 20.9-2.8 63.3-15.2 45.3-3.8 51.7 1.1 65.4 4.9 13.7 7.6 22.1 6.5 35s4.6 9.5 7.6 26.2c2.9 16.7.7 34.6.7 34.6z",
                  },
                }),
              ]),
              _c(
                "g",
                { attrs: { id: "R_trousers_1_-i2" } },
                [
                  _c(
                    "linearGradient",
                    {
                      attrs: {
                        id: "R_trousers_2_-i2_1_",
                        gradientUnits: "userSpaceOnUse",
                        x1: "4709.682",
                        y1: "-2889.686",
                        x2: "3635.702",
                        y2: "-2825.607",
                        gradientTransform:
                          "matrix(.1035 0 0 -.1036 -288.874 3.257)",
                      },
                    },
                    [
                      _c("stop", {
                        staticStyle: { "stop-color": "#f5f3f3" },
                        attrs: { offset: "0" },
                      }),
                      _c("stop", {
                        staticStyle: { "stop-color": "#f7f5f5" },
                        attrs: { offset: ".253" },
                      }),
                      _c("stop", {
                        staticStyle: { "stop-color": "#d8d8d8" },
                        attrs: { offset: "1" },
                      }),
                    ],
                    1
                  ),
                  _c("path", {
                    staticStyle: { fill: "url(#R_trousers_2_-i2_1_)" },
                    attrs: {
                      id: "R_trousers_2_-i2",
                      d: "M276.6 311.1s-106.4 36.4-130.7 21.1c-3.8-9.4-5.6-22.2 4.6-52.7 1.8-5.2 3.1-10.1 4.2-14.6.1-.3.2-.4.2-.4s4.2 23.5 26.3 20.7c22.1-2.8 21.4-3.5 32.6-.3 11.2 3.1 18.9-4.6 24.9-5.3 6-.7 25.9-1.8 30.8 3.9l7.1 27.6z",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("g", { attrs: { id: "sweater-i2" } }, [
              _c("path", {
                staticStyle: { fill: "#f1b505" },
                attrs: {
                  id: "sweater_4_-i2",
                  d: "M204.9 132.3c-16.4 23.6-28.8 35.5-29 60.3-.2 24.8-2.7 26.2-2.7 26.2s-13-4.8-25.2-1.6c-10.7 2.9-39.1 9.2-51.7.8-12.6-8.4-20.8-16.6-23.1-25.7l13.2-12.4c2.2 1.8 3.4 3.2 4.5 5.4 0 0 24.3-10.9 34.5-27.6s13.9-25.7 13.9-25.7-1.5 9 2.5 8.5c4-.6 11.5-10.5 11.5-10.5s7.9 3.6 14.2-12.8c6.3-16.4 7.1-28.4 6.5-31.5l41.8 2.7c.3-.1 5.5 20.3-10.9 43.9z",
                },
              }),
            ]),
            _c("g", { attrs: { id: "hands-i2" } }, [
              _c("path", {
                staticClass: "st17",
                attrs: {
                  id: "L_hand_1_-i2",
                  d: "M190.6 86.6s12.3-30.9 5.5-44.7c-6.8-13.7-11.9-22.8-11.9-22.8s3.4-2.3 6.4 2.3c3 4.5 5.1 7.2 5.6 4.5.6-2.6 3-22.4 3.8-24.5s3-2.3 3.6 1.3-2.2 15.1.5 12.9c2.6-2.3 5.5-13.2 6.1-13.8s8.3 5.8 10.5 12.1c2.3 6.2-3.8 15.6-7.5 21.3s-1.9 15.1 2.8 53.1l-25.4-1.7z",
                },
              }),
              _c("path", {
                staticClass: "st17",
                attrs: {
                  id: "R_hand_5_-i2",
                  d: "M75.4 170.9c5.5 4.5 8.9 6.9 11.2 8.9L73.7 192c-13.3 5-30.9 10.6-36.1 14-8.9 5.8-17.1 13.2-17.1 13.2-4-6.2 8.9-14.9 8.3-17.5-.6-2.6-2.8-3-16-3.6-13.2-.6-14.3-5.6-11.5-5.8 2.8-.2 13.6 1.3 14.5-.4.9-1.7-15.8 0-13.4-2.1.6-.5 1.4-1.1 2.3-1.7 3.5-2.4 7.9-3 11.9-1.8 8.7 2.6 20.3 5.4 24.3 4.9 4.8-.7 30.1-19.4 32.9-21.6.6.4 1.1.8 1.6 1.3z",
                },
              }),
            ]),
            _c("path", {
              staticClass: "st4",
              attrs: {
                id: "texture_2_-i2",
                d: "M174.4 89.7c0-.1 0-.1.1-.2.1 0 .1 0 .2.1 0 .1 0 .1-.1.2-.1 0-.2-.1-.2-.1zm6-2.8v-.2h-.2v.2h.2zm-5.8 7.7c.1 0 .1-.1.1-.2s-.1-.1-.2-.1-.1.1-.1.2.1.1.2.1zm1.3-7.9c.1-.1 0-.2 0-.2-.1-.1-.2 0-.2 0v.2c.1.1.2.1.2 0zm2.7 2.4c.1-.1 0-.2 0-.2-.1-.1-.2 0-.2 0-.1.1 0 .2 0 .2 0 .1.1.1.2 0zm2.7 2.3c.1-.1 0-.2 0-.2-.1-.1-.2 0-.2 0-.1.1 0 .2 0 .2 0 .1.1.1.2 0zm-7.7 8.6c.1 0 .1-.1.1-.2s-.1-.1-.2-.1-.1.1-.1.2c.1.1.2.2.2.1zm7.6-12.7c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zM185 89c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c0 0 .1 0 .2-.1zm-9.1 2.2c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2 0 .1.1.1.2 0zm2.8 3c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2 0 .1.2.1.2 0zm2.9 3c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2h.2zm-6.7-10c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zm3.3 1.5c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c0 0 .1 0 .2-.1zm3.2 1.4c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.1 0 .2-.1zm-5.2 4.6c.1-.1.1-.1 0-.2s-.1-.1-.2 0-.1.1 0 .2.2.1.2 0zm2.4 2.6c.1-.1.1-.1 0-.2s-.1-.1-.2 0-.1.1 0 .2h.2zm-4.2.6c0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1s0 .1.1.2c.1 0 .1-.1.2-.1zm2.8 1.4c0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1 0 .1 0 .1.1.2.1 0 .2 0 .2-.1zm-2.1-11.2c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c0 0 .1-.1.1-.2zm3-.9c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c0-.1.1-.2.1-.2zm-3.9 18.3c.1 0 .1-.1 0-.2 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2 0 .1.1.1.2 0zm2.9-12.1c0-.1 0-.1-.1-.1s-.1 0-.1.1 0 .1.1.1.1-.1.1-.1zm3.2.2c0-.1 0-.1-.1-.1s-.1 0-.1.1 0 .1.1.1c0 0 .1 0 .1-.1zm-4.7 11c.1-.1 0-.2 0-.2h-.2c-.1.1 0 .2 0 .2 0 .1.1 0 .2 0zm3.2 2.5c.1-.1 0-.2 0-.2-.1-.1-.2 0-.2 0-.1.1 0 .2 0 .2 0 .1.1.1.2 0zm-4-14.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2.2-.1.2-.2zm4.1-.5c0-.1-.1-.2-.2-.2s-.2.1-.1.2c0 .1.1.2.2.1 0 .1.1 0 .1-.1zm4.1-.4c0-.1-.1-.2-.2-.2s-.2.1-.1.2c0 .1.1.2.2.2 0-.1.1-.2.1-.2zm-11.6 19.1c.1 0 .1-.2.1-.2 0-.1-.2-.1-.2-.1-.1 0-.1.2-.1.2 0 .1.1.1.2.1zm2 3.6c.1 0 .1-.2.1-.2 0-.1-.1-.1-.2-.1s-.1.2-.1.2c0 .1.1.1.2.1zm2.9-16c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zm4 1.1c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zm4 1.1c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c0 .1.1 0 .2-.1zM175 87.4c0-.1-.2-.1-.2-.1-.1 0-.1.2-.1.2 0 .1.2.1.2.1.1 0 .1-.2.1-.2zm-3.4 21.8c.1 0 .1-.1 0-.2 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2h.2zm2.8-11c0-.1 0-.1-.1-.1s-.1 0-.1.1 0 .1.1.1l.1-.1zm3.1.3c0-.1 0-.1-.1-.1s-.1 0-.1.1 0 .1.1.1c0 .1.1 0 .1-.1zm-3.4 5.3c0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1 0 .1 0 .1.1.2.1 0 .1 0 .2-.1zm2.7 1.6c0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1v.2c.2 0 .3 0 .3-.1zM175.4 93c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c.1-.1.1-.1.1-.2zm3-.9c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.2-.1.1-.2zm-4.5 15v-.2h-.2v.2c.1.1.2.1.2 0zm3.2 2.1v-.2h-.2v.2c0 .1.1 0 .2 0zm-1.2-13.5c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c.1-.1.1-.1.1-.2zm3.7-.8c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.1-.1.1-.2zm-8.9 18.3c.1 0 .1-.1 0-.2 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2h.2zm2.1 3.1c.1 0 .1-.1 0-.2 0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2h.2zm1.3-14.8c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c.1.1.2 0 .2-.1zm3.7.7c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c.1.1.2 0 .2-.1zm3.7.7c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zm-6.4-13.4c0-.1-.1-.1-.2 0-.1 0-.1.1 0 .2 0 .1.1.1.2 0v-.2zm3.1-2.2c0-.1-.1-.1-.2 0s-.1.1 0 .2c0 .1.1.1.2 0v-.2zm-7.7 23.9c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0s-.1.2 0 .2c0 .1.1.1.2 0zm3.1 2.7c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2 0 .1.1.1.2 0zm3.1 2.7c.1-.1.1-.2 0-.2-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2 0 .1.1.1.2 0zm-3.3-14.5c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2c.2 0 .2-.1.2-.2zm4.1-.3c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2c.2 0 .2-.1.2-.2zm4.1-.3c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2c.2 0 .2-.1.2-.2zM174.9 86c-.1-.1-.2-.1-.2 0-.1.1-.1.2 0 .2.1.1.2.1.2 0 .1 0 .1-.1 0-.2zm-5.5 33.9c.1 0 .1-.1.1-.2s-.1-.1-.2-.1-.1.1-.1.2.1.2.2.1zm1.8 3.7c.1 0 .1-.1.1-.2s-.1-.1-.2-.1-.1.1-.1.2.1.2.2.1zm3.7-15.7c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2-.1.2-.1zm3.9 1.3c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2.2 0 .2-.1zm3.9 1.3c0-.1 0-.2-.1-.2s-.2 0-.2.1 0 .2.1.2c0 0 .1 0 .2-.1zm-8.6-13.8c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c.2 0 .2-.1.1-.2zm3.7-1.8c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.2-.1.1-.2zm3.7-1.8c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.2-.1.1-.2z",
              },
            }),
            _c(
              "g",
              { attrs: { id: "head_1_-i2" } },
              [
                _c("g", { attrs: { id: "hair_1_-i2" } }, [
                  _c("path", {
                    staticClass: "st18",
                    attrs: {
                      id: "hair_5_-i2",
                      d: "M152.9 100.2s-5.6-9-19.6-5-18.6 23-9.8 29.1c8.4 5.9 11.9 7.9 11.9 7.9s-12.2 3.8-23.3 1.4c-11-2.4-36.4-9.8-53.5 6.9 0 0 6 21.6 16.7 30.3s13.4 9.7 15.7 14.3c0 0 24.3-10.9 34.5-27.6s13.9-25.7 13.9-25.7.5-1.1.6-2.1c0 0 .1-3.2-2.5-4.1-3.6-1.3-2.3-.6-4.4-1.3-2.1-.7-4.5-4.3-2.3-6.8s4.1-1.5 6.1-2.1c2.2-.6 11.8-3.4 16-15.2z",
                    },
                  }),
                  _c("path", {
                    staticClass: "st18",
                    attrs: {
                      id: "hair_9_-i2",
                      d: "M58.3 137.7c11.3-8.1 24.2-10.1 37.6-7.2 10.7 2.3 20.9 6.1 32 4.9.4 0 .4-.6 0-.6-13.1 1.4-25.1-4.4-37.9-6-11.5-1.4-22.6 1.6-32 8.4-.3.2 0 .7.3.5z",
                    },
                  }),
                ]),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "neck_1_-i2_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "4206.462",
                      y1: "-1271.356",
                      x2: "4209.675",
                      y2: "-1140.872",
                      gradientTransform:
                        "matrix(.1035 0 0 -.1036 -288.874 3.257)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb5" },
                      attrs: { offset: ".033" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f49e95" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#neck_1_-i2_1_)" },
                  attrs: {
                    id: "neck_1_-i2",
                    d: "m153.5 129.8-.1.1c-.9 1.1-7.7 9.8-11.4 10.4-3.8.5-2.6-7.5-2.5-8.4v-.1c0-.1.5-1.2.6-2.1 0 0 0-.3-.1-.8 1.1.1 2.4.2 4 .2 3.5.1 6.1-.4 8-1.1-.2.4.4.9.8 1.3s.7.5.7.5z",
                  },
                }),
                _c("path", {
                  staticClass: "st17",
                  attrs: {
                    id: "face_6_-i2",
                    d: "M162.3 113c-1.6 1.4-2.6 1.2-2.8 2.4-.2.9.4 5.8-2.7 9.4l-.1.1v.1c-.3.4-1.5 1.9-4.4 3-1.9.7-4.5 1.2-8 1.1-1.6 0-2.9-.1-4-.2-.2-1-.7-2.7-2.4-3.3-3.6-1.3-2.3-.6-4.4-1.3-.1 0-.1 0-.2-.1-.3-.2-.7-.4-1-.6-.1 0-.2-.1-.2-.2-1.5-1.4-2.6-4-.8-5.9 2.2-2.5 4.1-1.5 6.1-2.1 1.7-.5 8.8-2.6 13.5-10.3 0-.1.1-.1.1-.2 1-1.5 1.6-3.2 2.2-4.7 0 0 4.9 7.1 7.5 8.7 2.4 1.7 3.2 2.7 1.6 4.1z",
                  },
                }),
                _c("g", { attrs: { id: "eyeglasses-i2" } }, [
                  _c("path", {
                    staticClass: "st18",
                    attrs: {
                      id: "eyeglasses_1_-i2",
                      d: "M163.1 102.8c-.5-2.2-2.3-3.7-4-3.3-1.8.4-2.8 2.5-2.3 4.7.1.3.1.5.2.7-1 .4-1.7 1.4-2.1 2.4l-.3-.3c-.9-.7-1.9-1-2.9-.8-2 .4-3.2 2.9-2.7 5.4.3 1.2.9 2.3 1.8 3 .7.6 1.5.9 2.3.9.2 0 .4 0 .7-.1 1-.2 1.8-.9 2.3-1.9.5-1 .6-2.2.4-3.5-.2-.9-.6-1.6-1-2.3.4-.9.9-2 1.9-2.4.7 1.3 1.8 2.1 3 2.1.2 0 .4 0 .6-.1 1.5-.2 2.6-2.3 2.1-4.5zm-7.7 10.5c-.4.9-1.1 1.4-1.9 1.6-.8.2-1.7-.1-2.4-.7-.8-.6-1.3-1.6-1.6-2.7-.5-2.2.5-4.3 2.2-4.7.2 0 .3-.1.5-.1.7 0 1.3.3 1.9.7.8.6 1.3 1.6 1.6 2.7.3 1.2.2 2.3-.3 3.2zm5.2-6.4c-1.4.3-2.9-1-3.3-2.8-.4-1.9.4-3.6 1.9-3.9 1.4-.3 2.9 1 3.3 2.8.4 1.8-.4 3.6-1.9 3.9z",
                    },
                  }),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(1.69 0 0 1.69 945 534)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_9_", d: "M-103.5-103.5h507v507h-507z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_10_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_9_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_10_)" } }, [
          _c("circle", {
            staticClass: "st6",
            attrs: { cx: "150", cy: "150", r: "150" },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: {
              d: "M186.7 69.1c0-16.8 13.7-30.4 30.7-30.4s30.7 13.6 30.7 30.4c.6-.6-61.4 0-61.4 0z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: {
              d: "M252 69.1h-7.8c0-14.8-12-26.8-26.8-26.8s-26.8 12.1-26.8 26.8h-7.8c0-18.8 15.5-34.6 34.6-34.6S252 50.3 252 69.1z",
            },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: {
              d: "M195.8 213.4c16.8 0 30.4 13.7 30.4 30.7s-13.6 30.7-30.4 30.7c0 0 .1-61.5 0-61.4z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: {
              d: "M195.8 278.6v-7.8c14.8 0 26.8-12 26.8-26.8s-12.1-26.8-26.8-26.8v-7.8c18.8 0 34.6 15.5 34.6 34.6s-15.8 34.6-34.6 34.6z",
            },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: {
              d: "M45.9 117.7c-16.8 0-29.4 13.8-30.4 30.7-1.4 22.1 30 32.1 30.4 30.7v-61.4z",
            },
          }),
          _c("path", {
            staticClass: "st8",
            attrs: {
              d: "M45.9 183v-7.8c-14.8 0-26.8-12-26.8-26.8s12.1-26.8 26.8-26.8v-7.8c-18.8 0-34.6 15.5-34.6 34.6 0 19 15.8 34.6 34.6 34.6z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: { d: "M237.9 107.6h-49l39-50.3 7.9 6.1-26.5 34.2h28.6z" },
          }),
          _c("path", {
            staticClass: "st8",
            attrs: {
              transform: "rotate(-52.21 50.011 190.955)",
              d: "M23.3 186h53.5v10H23.3z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: { d: "M184.3 236.2h-10v-48.1h49v10h-39z" },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: {
              id: "texture-3_7_-i3",
              d: "M169.9 234c-.1-.3.1-.7.4-.8.3-.1.6.1.7.4.1.3-.1.7-.4.8-.3.1-.6-.1-.7-.4zm14-4c-.1-.3.1-.7.4-.8.3-.1.7.1.8.4.1.3-.1.7-.4.8-.3.1-.7-.1-.8-.4zm-6.7-57.4c.2-.3.5-.4.8-.2.3.2.4.5.2.8-.2.3-.5.4-.8.2-.3-.1-.4-.5-.2-.8zm25.4 14.2c.2-.3.5-.4.8-.2.3.2.4.5.3.8-.2.3-.6.4-.9.2-.3-.1-.4-.5-.2-.8zm12.7 7.2c.2-.3.5-.4.8-.2.3.2.4.5.3.8-.2.3-.5.4-.8.2-.3-.2-.4-.5-.3-.8zm10-58.9c-.1-.3.1-.7.4-.8.3-.1.6.1.7.4v.1c.1.3-.1.6-.4.7-.3.1-.6 0-.7-.4zm-50.1 69c0-.3.3-.6.6-.5.3 0 .6.3.5.6 0 .3-.3.6-.6.5-.3 0-.5-.2-.5-.6zm28.9 3.4c.1-.3.4-.5.7-.5.3 0 .6.3.5.6 0 .3-.3.6-.6.5-.4 0-.6-.2-.6-.6zm14.5 1.7c0-.3.3-.5.6-.5h.1c.3 0 .6.3.5.6 0 .3-.3.6-.6.5-.4.1-.6-.2-.6-.6zm-16.5-53.5c-.2-.3-.1-.6.1-.9.3-.2.7-.2.9.1.2.3.2.7-.1.9-.3.2-.6.1-.9-.1zm9.1 11.4c-.2-.3-.1-.6.1-.8.2-.2.6-.2.8 0 .2.3.1.6-.1.9-.2.2-.6.2-.8-.1zm-98.7 51.7c0-.6.6-1.1 1.2-1.1s1.1.6 1.1 1.2-.6 1.1-1.2 1.1c-.7-.1-1.1-.6-1.1-1.2zm27.6 1.3c0-.6.6-1.1 1.2-1.1s1.1.6 1.1 1.2-.6 1.1-1.2 1.1c-.7 0-1.2-.5-1.1-1.2zm27.5 1.4c0-.6.6-1.1 1.2-1.1s1.1.6 1.1 1.2-.6 1.1-1.2 1.1-1.1-.5-1.1-1.2zM135 113.2c-.4-.5-.4-1.2.1-1.6.4-.4 1.1-.4 1.6 0 .4.5.4 1.2-.1 1.6-.4.5-1.1.4-1.6 0zm18.5 20.5c-.4-.5-.4-1.2.1-1.6.5-.4 1.2-.4 1.6.1.4.5.4 1.2-.1 1.6-.4.3-1.1.3-1.6-.1zm18.6 20.4c-.4-.5-.4-1.2.1-1.6.4-.4 1.1-.4 1.6 0 .4.5.4 1.2-.1 1.7s-1.2.4-1.6-.1zm37 41c-.4-.5-.4-1.2.1-1.6.5-.4 1.2-.4 1.6.1.4.4.4 1.2-.1 1.6-.4.4-1.2.4-1.6-.1zM131.9 264c-.2-.6.1-1.2.7-1.5.6-.2 1.2.1 1.5.7.2.6-.1 1.2-.7 1.5s-1.3-.1-1.5-.7zm26-9.3c-.2-.6.1-1.2.6-1.5.6-.2 1.2.1 1.5.6v.1c.2.6-.1 1.2-.7 1.4-.5.3-1.1 0-1.4-.6zm-47.5-87.9c.3-.6 1-.8 1.5-.5.6.3.8 1 .5 1.5-.3.5-.9.8-1.5.5-.5-.3-.8-.9-.5-1.5zm25 11.8c.3-.6 1-.8 1.5-.5.6.3.8 1 .5 1.5-.3.5-.9.8-1.5.5-.6-.2-.8-.9-.5-1.5zm24.9 11.8c.3-.6 1-.8 1.6-.5.6.3.8.9.5 1.5-.3.6-.9.9-1.5.6s-.9-.9-.6-1.6c0 .1 0 .1 0 0zm27.8-94.2c-.2-.6.1-1.2.7-1.5.6-.2 1.2.1 1.4.7.2.6 0 1.2-.6 1.4h-.1c-.5.2-1.1-.1-1.4-.6zm9.3 26c-.2-.6.1-1.2.7-1.5.6-.2 1.2.1 1.5.7.2.6-.1 1.2-.7 1.4-.6.3-1.3 0-1.5-.6zm9.3 26c-.2-.6.1-1.2.6-1.4h.1c.6-.2 1.2.1 1.5.6v.1c.2.6-.1 1.2-.7 1.5s-1.3-.2-1.5-.8zm9.2 26c-.2-.6.1-1.2.7-1.5.6-.2 1.2.1 1.4.6v.1c.2.6-.1 1.2-.7 1.5-.5.2-1.1-.1-1.4-.7zM99.4 191.6c.2-.5.8-.8 1.3-.6s.8.8.6 1.3c-.2.5-.8.8-1.3.6-.5-.2-.7-.8-.6-1.3zm23.2 8.4c.2-.5.8-.8 1.3-.6.5.2.8.7.7 1.3s-.7.8-1.3.6h-.1c-.5-.2-.8-.8-.6-1.3zm23.2 9.1c-.1-.2-.1-.5 0-.7.2-.5.8-.8 1.3-.6.5.2.8.8.6 1.3-.1.3-.4.6-.7.6-.2.1-.4 0-.6-.1-.3 0-.5-.2-.6-.5zm23.2 7.6c.2-.5.8-.8 1.3-.6.5.2.8.8.6 1.3-.2.5-.8.8-1.3.6-.6-.1-.8-.7-.6-1.3zm.5-100.9c-.2-.5 0-1.1.5-1.4.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.4-.5.2-1.1 0-1.3-.5zm10.4 22.2c-.2-.5 0-1.1.5-1.3.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.4-.5.2-1.1 0-1.3-.6zm10.5 22.4c-.2-.5 0-1.1.5-1.4.5-.2 1.1-.1 1.3.4v.1c.2.5 0 1.1-.5 1.4-.5.2-1.1 0-1.3-.5zm10.4 22.3c-.2-.5 0-1.1.5-1.4.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.4-.4.2-1 0-1.3-.5zm10.5 22.3c-.2-.5 0-1.1.5-1.4.5-.2 1.1 0 1.4.5.2.5 0 1.1-.5 1.4-.6.2-1.2 0-1.4-.5zm-83.6 39.3c0-.6.4-1 .9-1.1h.1c.5 0 1 .4 1 .9v.1c0 .6-.4 1-.9 1.1-.6 0-1.1-.4-1.1-1zm73.9-3.3c0-.6.4-1 1-1.1.6 0 1 .4 1.1 1 0 .6-.4 1-1 1.1-.6 0-1.1-.4-1.1-1zm-66.8-83.8c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4-.1.4.4.4 1 .1 1.5-.4.4-1.1.4-1.5 0zm18.2 16.6c-.4-.4-.5-1-.1-1.4.4-.4 1-.4 1.4-.1.4.4.4 1 .1 1.5-.3.4-1 .4-1.4 0zm18.2 16.7c-.4-.4-.4-1-.1-1.4.4-.4 1-.4 1.4-.1.4.4.4 1 .1 1.4-.3.4-1 .4-1.4.1zm48.4-74.7c0-.5.4-1 .9-1h.1c.6 0 1 .4 1.1.9 0 .6-.4 1-1 1.1-.6 0-1.1-.4-1.1-1zm1.1 24.6c0-.6.4-1.1 1-1.1s1 .4 1.1 1c0 .5-.4 1-.9 1.1-.7.1-1.2-.3-1.2-1 0 .1 0 .1 0 0zm-82.3 98.2c.1-.3.4-.6.7-.5s.6.4.5.7-.4.6-.7.5c-.3 0-.6-.3-.5-.7zm28.7 4.5c.1-.3.4-.5.7-.5.3 0 .5.3.5.6v.1c-.1.3-.4.5-.7.5-.3 0-.5-.3-.5-.7 0 .1 0 .1 0 0zm3.3-56.3c-.2-.3-.1-.6.1-.8.3-.2.6-.1.8.1.2.3.1.6-.1.8-.3.3-.6.2-.8-.1zm34.2 47c-.2-.3-.1-.6.1-.8.3-.2.6-.1.8.1.2.3.1.6-.1.8-.2.2-.6.2-.8-.1zm-57.2 35.4c-.1-.3.1-.6.4-.7.3-.1.7.1.7.5.1.3-.1.6-.4.7-.3 0-.6-.2-.7-.5zm14.1-3.4c-.1-.3.1-.6.4-.7.3-.1.6.1.7.4.1.3-.1.6-.4.7h-.1c-.2.1-.5-.1-.6-.4zm-5.9-52.1c.2-.3.5-.4.8-.2.3.2.4.5.2.8-.1.3-.5.4-.8.2-.3-.1-.4-.5-.2-.8zm12.4 7.6c.2-.3.5-.4.8-.2.3.2.4.5.2.8-.1.3-.5.4-.8.2-.2-.1-.3-.5-.2-.8zm12.4 7.6c.1-.3.5-.4.8-.2h.1c.3.2.4.6.2.8-.2.3-.5.4-.8.2-.3-.1-.4-.5-.3-.8zm19.8-47.9c-.1-.3.1-.6.4-.7.3-.1.6.1.7.4.1.3-.1.6-.4.7h-.1c-.2.1-.5 0-.6-.4zm3.4 14.2c-.1-.3.1-.7.5-.7.3-.1.6.1.7.4.1.3-.1.6-.4.7h-.1c-.3.1-.6-.1-.7-.4zm3.4 14.1c-.1-.3.1-.7.5-.7.3-.1.7.1.7.5.1.3-.2.7-.5.7s-.6-.2-.7-.5zm-85.7 24.4c.1-.3.5-.5.8-.4.4.1.6.5.4.8v.1c-.1.3-.5.5-.8.4-.3-.2-.5-.5-.4-.9zm15.7 5.5c.1-.4.5-.6.9-.4.4.1.6.5.4.9-.1.3-.5.5-.8.4-.4-.1-.7-.5-.5-.9-.1 0 0 0 0 0zm30.9-57.1c-.2-.3-.1-.7.2-.9h.1c.3-.2.7 0 .9.3.1.4 0 .7-.3.9-.3.2-.7.1-.9-.3zm7.2 15c-.2-.4 0-.8.4-.9.3-.2.7 0 .9.3.1.4 0 .7-.3.9-.4.2-.8 0-1-.3zm14.4 29.9c-.2-.3-.1-.7.2-.9 0 0 .1 0 .1-.1.3-.2.7 0 .9.3.2.3 0 .8-.3.9-.3.3-.7.2-.9-.2zm-64.2 42.4c0-.4.2-.7.6-.8.4 0 .7.3.7.7 0 .4-.3.7-.6.7-.4.1-.7-.2-.7-.6zm16.6-.9c0-.4.3-.7.6-.7.4 0 .7.2.8.6 0 .4-.3.7-.7.7-.4 0-.7-.2-.7-.6zm16.5-.9c0-.4.2-.7.6-.7h.1c.4 0 .7.2.7.6 0 .4-.2.7-.6.8-.4 0-.7-.3-.8-.7zm-12.6-58.5c0-.1.1-.2.1-.3.2-.3.7-.3.9-.1.3.2.3.7.1.9-.2.3-.7.3-.9.1-.2-.1-.3-.4-.2-.6zm12.6 11.7c-.3-.2-.3-.7-.1-.9.2-.3.7-.3 1-.1.3.3.3.7.1 1-.3.3-.7.3-1 0zm12.4 11.1c-.3-.3-.3-.7 0-1 .3-.3.7-.3 1 0 .3.3.3.7 0 1-.3.2-.8.3-1 0zm32-50.6c0-.4.3-.7.6-.7.4 0 .7.3.7.6 0 .4-.2.7-.6.7h-.1c-.2.1-.6-.2-.6-.6zm.9 16.6c0-.4.2-.7.6-.7h.1c.4 0 .7.2.7.6v.1c0 .4-.3.7-.6.8-.4-.2-.8-.5-.8-.8zm.9 16.5c0-.4.3-.7.6-.7.4 0 .7.3.7.6 0 .4-.2.7-.6.8-.3 0-.6-.3-.7-.7zM82.9 171.3c-.5-.5-.5-1.2 0-1.7.4-.5 1.2-.5 1.7-.1.5.5.5 1.2 0 1.7s-1.2.5-1.7.1zm20.8 19.4c-.5-.4-.5-1.2-.1-1.7s1.2-.5 1.7-.1.5 1.2.1 1.7-1.2.5-1.7.1zm20.8 19.4c-.5-.5-.5-1.2 0-1.7s1.2-.5 1.7 0 .5 1.2 0 1.7c-.5.4-1.2.4-1.7 0zm41.7 38.8c-.5-.5-.5-1.2 0-1.7.4-.5 1.2-.5 1.7 0 .5.4.5 1.2 0 1.6-.5.5-1.2.5-1.7.1zm25.3-128.2c0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2c0 .6-.5 1.2-1.1 1.2-.7 0-1.2-.5-1.3-1.2zm1 28.5c0-.6.5-1.2 1.1-1.2.6 0 1.2.5 1.2 1.1s-.5 1.2-1.1 1.2c-.6 0-1.1-.5-1.2-1.1zm1 28.4c0-.6.5-1.2 1.1-1.2.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2c-.5-.1-1-.6-1.1-1.2zm-77.9 69.9c.2-.6.9-.9 1.5-.7.6.2.9.9.7 1.5-.2.6-.9.9-1.5.7-.6-.2-.9-.9-.7-1.5zm26.7 10c.2-.6.9-1 1.5-.8.6.2.9.9.7 1.5-.2.6-.9.9-1.5.7-.6-.1-.9-.8-.7-1.4zm26.7 9.9c.2-.6.9-.9 1.5-.7.6.2.9.9.6 1.4v.1c-.2.6-.8.9-1.4.7h-.1c-.6-.2-.9-.8-.6-1.5-.1.1-.1.1 0 0zm-33.1-119.2c-.2-.6 0-1.3.6-1.6.6-.2 1.3 0 1.5.6.3.6 0 1.3-.5 1.5-.6.4-1.3.1-1.6-.5zm11.9 25.9c-.3-.6 0-1.3.6-1.6.6-.3 1.3 0 1.5.6.3.6 0 1.3-.6 1.6-.6.3-1.3 0-1.5-.6zm11.8 25.9c-.3-.6 0-1.3.5-1.5.6-.3 1.3-.1 1.6.5.3.6.1 1.3-.5 1.6-.6.3-1.3 0-1.6-.6zm11.8 25.9c-.3-.6 0-1.3.6-1.5.6-.2 1.2 0 1.5.6.3.6 0 1.3-.6 1.6-.6.1-1.3-.1-1.5-.7zm-51.5 41.9c.2-.6.9-.9 1.5-.8.6.2.9.9.7 1.5-.2.6-.8.9-1.4.8h-.1c-.6-.2-.9-.9-.7-1.5zm-3.2-116.2c-.3-.6 0-1.3.6-1.6.6-.3 1.3 0 1.6.6.3.6 0 1.2-.5 1.5-.7.4-1.4.1-1.7-.5zm12.8 25.3c-.3-.6-.1-1.3.5-1.6.6-.3 1.3-.1 1.6.5.3.6.1 1.3-.5 1.6-.6.3-1.3.1-1.6-.5zm12.9 25.3c-.3-.6-.1-1.3.5-1.6.6-.3 1.3-.1 1.6.5.3.6.1 1.3-.5 1.6-.6.3-1.3.1-1.6-.5zm12.8 25.3c-.3-.6-.1-1.2.4-1.5h.1c.6-.3 1.3-.1 1.6.5.3.6.1 1.3-.5 1.6-.6.2-1.3-.1-1.6-.6zm62.8-32.1c.2-.6.9-.9 1.5-.7.6.2.9.9.7 1.5-.2.6-.8.9-1.4.8h-.1c-.5-.3-.9-.9-.7-1.6 0 .1 0 .1 0 0zm-116.4 23.5c-.5-.4-.5-1.1-.1-1.6s1.2-.6 1.7-.2c.5.4.5 1.2.1 1.7-.5.5-1.2.5-1.7.1zm21.5 18.5c-.5-.4-.6-1.1-.1-1.6.4-.5 1.2-.6 1.7-.1.5.4.5 1.2.1 1.7-.4.3-1.2.4-1.7 0zm21.5 18.4c-.5-.4-.5-1.2-.1-1.7s1.1-.5 1.6-.1.6 1.2.1 1.7c-.3.5-1.1.5-1.6.1zm31.4-106c0-.6.5-1.2 1.1-1.3.6 0 1.2.4 1.2 1.1.1.6-.4 1.2-1 1.3h-.1c-.6 0-1.2-.5-1.2-1.1-.1 0-.1 0 0 0zm2.1 28.2c0-.6.5-1.2 1.1-1.3.6 0 1.2.4 1.2 1.1.1.6-.4 1.2-1 1.3h-.1c-.5.1-1.1-.4-1.2-1.1zm4.4 56.6c0-.6.5-1.2 1.1-1.3.6 0 1.2.4 1.2 1.1 0 .6-.4 1.2-1.1 1.3-.6 0-1.1-.5-1.2-1.1zm-51.1 41.3c.2-.4.8-.6 1.2-.3.4.2.6.8.3 1.2-.2.4-.8.6-1.2.3-.3-.2-.5-.8-.3-1.2zm16-86.1c-.1-.5.2-1 .6-1.1.5-.1.9.1 1.1.6.1.4-.1.9-.6 1.1h-.1c-.4.1-.9-.2-1-.6zm5.5 20.6c-.1-.5.2-1 .6-1.1.5-.1 1 .2 1.1.6.1.5-.1.9-.6 1.1-.5.2-1-.1-1.1-.6zm5.5 20.7c-.1-.5.2-1 .6-1.1.5-.1 1 .2 1.1.6s-.2 1-.6 1.1c-.5.1-1-.2-1.1-.6zM113 219.4c-.3-.4-.2-.9.2-1.2.4-.3.9-.2 1.2.2.3.4.2.9-.2 1.2-.3.3-.8.3-1.2-.2.1.1 0 0 0 0zm13 17c-.3-.4-.2-1 .2-1.3.4-.3.9-.2 1.2.2.3.4.2.9-.1 1.2-.4.4-1 .3-1.3-.1zm13 17c-.3-.4-.2-.9.1-1.2h.1c.4-.3.9-.2 1.2.1.3.4.2 1-.2 1.3-.3.3-.9.2-1.2-.2zm49.9-35.1c.1-.5.6-.8 1-.7.5.1.8.5.8 1-.1.5-.5.8-1 .8-.6-.2-.9-.6-.8-1.1zm-51 41.5c-.1-.2-.1-.5.2-.7.2-.1.5-.1.7.2.1.2.1.5-.2.7-.3.1-.6.1-.7-.2zm5.5 10.3c-.1-.2 0-.5.2-.6.2-.1.5-.1.6.1v.1c.1.2.1.5-.1.6-.3.1-.6 0-.7-.2zm18.8-11.6c0-.3.1-.5.4-.5.3 0 .5.2.5.4s-.1.5-.4.5c-.2.1-.4-.1-.5-.4zm1.2 11.6c0-.3.2-.5.4-.5.3 0 .5.2.5.4s-.2.5-.4.5c-.3.1-.5-.1-.5-.4zM137 236.6c0-.4.3-.8.7-.9.4-.1.8.2.8.6v.1c.1.4-.2.8-.6.9h-.1c-.3 0-.7-.3-.8-.7zm2 19.2c-.1-.4.2-.8.6-.9h.1c.4-.1.8.2.9.7v.1c0 .4-.3.8-.7.9-.4 0-.8-.3-.9-.8zm2 19.2c0-.4.3-.8.7-.9.4-.1.8.2.9.7 0 .4-.3.8-.7.9-.5.1-.8-.2-.9-.7zm28.7-6c-.1-.2-.1-.4-.1-.6.1-.4.6-.7 1-.5.2.1.3.2.4.4v.1c.1.2.1.4.1.6-.1.4-.6.7-1 .5-.1-.2-.2-.4-.4-.5z",
            },
          }),
          _c("path", {
            staticClass: "st21",
            attrs: {
              d: "M151.8 149.9c-1.7-1.1-3.5-2.2-5.2-3.4-18.7-13.1-31-35.4-32-58.3-1-22.8 9.3-46.1 26.9-60.8l2.8 3.3C127.7 44.5 118 66.5 119 88s12.5 42.6 30.1 54.9c1.7 1.2 3.4 2.3 5.1 3.3l-2.4 3.7z",
            },
          }),
          _c("path", {
            staticClass: "st10",
            attrs: {
              d: "M140.1 48.9 159 16.6l-39 15.6 18.9 1.2zM198.5 149.2l48.5 2.4-41.3-35.5 9.9 22.5z",
            },
          }),
          _c("path", {
            staticClass: "st10",
            attrs: {
              d: "M148.8 158.5c-.7 0-1.4-.3-2-.8-1.1-1.1-1.2-2.9-.1-4 20.9-22.2 56.8-27.7 83.5-12.8 1.4.8 1.9 2.5 1.1 3.9s-2.5 1.9-3.9 1.1c-24-13.4-57.6-8.2-76.5 11.8-.5.5-1.3.8-2.1.8z",
            },
          }),
          _c("circle", {
            staticClass: "st21",
            attrs: { cx: "150", cy: "150", r: "11.2" },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(1.54359 0 0 1.548 810 648)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_11_", d: "M-53-68.5h301v387H-53z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_12_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_11_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_12_)" } },
          [
            _c("path", {
              staticClass: "st23",
              attrs: {
                d: "M0 28.5v5.8h4.2v-2.2h6.2v6.2H4.2v-2.1H0v9.1h4.2v-2.2h6.2v6.2H4.2v-2.1H0v9h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2V76h6.2v6.2H4.2v-2.1H0v9h4.2V87h6.2v6.2H4.2V91H0v9.1h4.2V98h6.2v6.2H4.2V102H0v9.1h4.2v-2.2h6.2v6.2H4.2V113H0v9h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2v-2.2h6.2v6.2H4.2v-2.1H0v3.3h98V28.5z",
              },
            }),
            _c("path", {
              staticClass: "st23",
              attrs: {
                d: "M0 83.5v5.8h4.2v-2.2h6.2v6.2H4.2v-2.1H0v9h4.2v-2.1h6.2v6.2H4.2v-2.1H0v9h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2V120h6.2v6.2H4.2v-2.1H0v9.1h4.2V131h6.2v6.2H4.2v-2.1H0v9h4.2V142h6.2v6.2H4.2V146H0v9.1h4.2v-2.2h6.2v6.2H4.2V157H0v9.1h4.2v-2.2h6.2v6.2H4.2V168H0v9h4.2v-2.1h6.2v6.2H4.2v-2.2H0v9.1h4.2v-2.1h6.2v6.1H4.2v-2.1H0v9.1h4.2v-2.2h6.2v6.2H4.2v-2.1H0v3.2h98V83.5z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#dadbdc" },
              attrs: { d: "M15.3 17.1h176.3v230.7H15.3z" },
            }),
            _c("path", {
              staticClass: "st25",
              attrs: { d: "m19.5 20.1 171.8-2.9 3.7 226.3-171.7 2.9z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "m25.8 22.7 163.8 1-1.4 226.3-163.8-1z" },
            }),
            _c("path", {
              staticStyle: { fill: "#151a4f" },
              attrs: { d: "M80.6 4.5H126v2.1H80.6z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_13_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-494.276",
                  y1: "113.676",
                  x2: "-494.414",
                  y2: "92.369",
                  gradientTransform: "matrix(1.5436 0 0 -1.548 866.345 182.76)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_13_)" },
              attrs: { d: "M80.6 6.5H126v19.6H80.6z" },
            }),
            _c("path", {
              staticClass: "st28",
              attrs: {
                d: "M99.7 24.8H77.9v-2h20.8v-3.3l-11-17.9.8-1.6h16.1v2.1H90.4l10.2 16.5.2.6v4.6z",
              },
            }),
            _c("path", {
              staticClass: "st28",
              attrs: {
                d: "M128.3 24.8h-21.8l-1-1v-4.6l.1-.6 10.2-16.5h-14.2V0h16.1l.9 1.6-11.1 17.9v3.3h20.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_14_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-505.028",
                  y1: "103.696",
                  x2: "-504.926",
                  y2: "98.096",
                  gradientTransform: "matrix(1.5436 0 0 -1.548 866.345 182.76)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_14_)" },
              attrs: { d: "M79.2 21.9h15.1v4.2H79.2z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_15_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-483.704",
                  y1: "104.065",
                  x2: "-483.946",
                  y2: "97.77",
                  gradientTransform: "matrix(1.5436 0 0 -1.548 866.345 182.76)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_15_)" },
              attrs: { d: "M111.8 21.9h15.6v4.2h-15.6z" },
            }),
            _c("path", {
              staticClass: "st25",
              attrs: {
                d: "M38 73.2h6.2v4.2H38zM119.6 77.4H107v-4.2h12.6v4.2zm-25.1 0H81.9v-4.2h12.6v4.2zm-25.1 0H56.8v-4.2h12.6v4.2zM132.2 73.2h6.2v4.2h-6.2zM38 107.5h6.2v4.2H38zM119.6 111.7H107v-4.2h12.6v4.2zm-25.1 0H81.9v-4.2h12.6v4.2zm-25.1 0H56.8v-4.2h12.6v4.2zM132.2 107.5h6.2v4.2h-6.2zM38 141.8h6.2v4.2H38zM119.6 146H107v-4.2h12.6v4.2zm-25.1 0H81.9v-4.2h12.6v4.2zm-25.1 0H56.8v-4.2h12.6v4.2zM132.2 141.8h6.2v4.2h-6.2z",
              },
            }),
            _c("g", [
              _c("path", {
                staticClass: "st25",
                attrs: {
                  d: "M38 176.1h6.2v4.2H38zM119.6 180.2H107V176h12.6v4.2zm-25.1 0H81.9V176h12.6v4.2zm-25.1 0H56.8V176h12.6v4.2zM132.2 176.1h6.2v4.2h-6.2z",
                },
              }),
            ]),
            _c("g", [
              _c("path", {
                staticClass: "st25",
                attrs: {
                  d: "M173.8 79h-26.5V52.5h26.5V79zm-22.4-4.2h18.2V56.6h-18.2v18.2z",
                },
              }),
            ]),
            _c("g", [
              _c("path", {
                staticClass: "st25",
                attrs: {
                  d: "M173.8 148.6h-26.5v-26.5h26.5v26.5zm-22.4-4.2h18.2v-18.2h-18.2v18.2z",
                },
              }),
            ]),
            _c("g", [
              _c("path", {
                staticClass: "st25",
                attrs: {
                  d: "M173.8 218.1h-26.5v-26.5h26.5v26.5zm-22.4-4.1h18.2v-18.2h-18.2V214z",
                },
              }),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "g",
        { attrs: { transform: "matrix(-1.02033 0 0 1.0225 1143 343)" } },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_16_", d: "M-2.5-4.5h251v409h-251z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_17_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_16_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_17_)" } }, [
            _c(
              "g",
              { attrs: { id: "woman-i5" } },
              [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    id: "R_shoe-i5",
                    d: "M152.1 364.3h29.4s12.7 13.5 28.1 20.2c15.5 6.6 20.1 15.6 20.1 15.6h-90.4l12.8-35.8",
                  },
                }),
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    id: "L_shoe-i5",
                    d: "m162.7 316.4 28.8-6s15.2 10.6 31.7 13.9 22.9 11.1 22.9 11.1L157.5 354l5.2-37.6",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "L_trousers-i5_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "-2643.875",
                      y1: "-2647.404",
                      x2: "-4335.943",
                      y2: "-3521.508",
                      gradientTransform:
                        "matrix(-.0756 0 0 -.07577 22.816 -23.424)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#23286b" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#151a4f" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#L_trousers-i5_1_)" },
                  attrs: {
                    id: "L_trousers-i5",
                    d: "M68.7 158.3s66.9 11.8 84.3 18.9c17.4 7.1 18.6 26 26.2 65.1 8.8 45.5 12.8 68.3 12.8 68.3l-32.8 6.7s-11.5-5.8-15.4-25.6-1.8-21.7-6.6-32.4c-4.7-10.7-8.5-16.4-8.5-30.1 0-13.7-7.9-20.5-19.7-19.7-11.8.7-64.2.2-86.5-35.8l-5-8c.1-.2 37.1-14.8 51.2-7.4",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "L_hand-i5_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "-1446.579",
                      y1: "-930",
                      x2: "-1358.855",
                      y2: "-1392.537",
                      gradientTransform:
                        "matrix(-.0756 0 0 -.07577 22.816 -23.424)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#L_hand-i5_1_)" },
                  attrs: {
                    id: "L_hand-i5",
                    d: "M133.3 96.9s6.6-2.8 6.6-7.9c0-5.1 8.7-8.7 8.7-8.7l-6.7 13.4-3.5 7.5c-.1 0-7.4 12.4-5.1-4.3z",
                  },
                }),
                _c("path", {
                  staticClass: "st10",
                  attrs: {
                    id: "R_trousers-i5",
                    d: "M129.2 337c3.8 8.7 14.7 21.9 22.9 27.3h29.4c-1.2-5-26.2-107.9-36.1-126-8-14.8-19.4-30.4-30.7-44l-28.2-33-28 5.6c-1-.4-2.8-.7-3.9-1.1-2-.7-3.9 7-6.5 5.2-4.4 2.2-28 .2-31.3 1.5 2.1 24 22.7 41.7 47.2 53.7 45.6 22.4 37.3 33.5 41.1 48.5 3.8 15 6.5 23.9 15.2 34.7 8.7 10.7 1.7 11.1 8.9 27.6z",
                  },
                }),
                _c("path", {
                  staticClass: "st10",
                  attrs: {
                    id: "phone-i5",
                    d: "m158.7 97.5-17-3.9c-1-.2-1.6-1.2-1.4-2.2.1-.3.2-.5.3-.7L163 61.2c.5-.6 1.2-.9 1.9-.7l17.1 4.3c1 .2 1.6 1.3 1.4 2.3-.1.3-.2.5-.3.7l-22.6 29.1c-.4.5-1.1.8-1.8.6z",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "R_hand-i5_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "-1733.089",
                      y1: "-1598.333",
                      x2: "-2021.849",
                      y2: "-1883.391",
                      gradientTransform:
                        "matrix(-.0756 .00077 -.00077 -.07577 22.581 -24.378)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#R_hand-i5_1_)" },
                  attrs: {
                    id: "R_hand-i5",
                    d: "M134.9 100.9s4.9-3.7 7-7.2c0 0 3.2.7 5.2 1.1 0 0 .3-5.1 10.3-5.9 9-.8 7.9-2.7 13.4-4.6 5.6-1.8 7.9-.2 8.2 1.7 0 0-5.9 2.1-7.2 4.3s-3 7.5-7.9 9.2-21.8 3.1-25.4 14.4l-3.6-13",
                  },
                }),
                _c("path", {
                  staticClass: "st35",
                  attrs: {
                    id: "texture-3-i5",
                    d: "M55.3 188c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .1 0 .2.1.3zm2-4.6c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.2-.1.3.1.3zm1.9-4.5c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .2.1.3zm1.9-4.6c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .3.1.3zM76 187.9c0 .1.2.2.3.1.1 0 .1-.1.1-.2s-.2-.2-.3-.1c0 0-.1.1-.1.2zM48.2 180c.1.1.2.1.3 0 .1-.1.1-.2 0-.3s-.2-.1-.3 0v.3zm3.5-3.5c.1.1.2.1.2 0 0 0 .1-.1.1-.2 0 0 0-.1-.1-.1-.1-.1-.2-.1-.3 0 .1.1.1.2.1.3zm3.6-3.5c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3-.1 0-.1 0 0 0zm10.3 14.3c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm0-5c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-37.2 6.9c.1.2.4.2.5 0 .2-.1.2-.4 0-.5-.1-.2-.4-.2-.5 0-.1.1-.1.3 0 .5zm7.1-6.1c.1.2.4.2.5 0 .2-.1.2-.4 0-.6-.1-.2-.4-.2-.5 0-.1.1-.1.4 0 .6zm7.1-6.2c.1.2.4.2.5 0 .2-.1.2-.4 0-.6-.1-.2-.4-.2-.5 0-.2.2-.2.4 0 .6zm13.9 35.8c0 .2.2.4.4.4s.4-.1.4-.3c0-.2-.2-.4-.4-.4-.2-.1-.3 0-.4.3zm.7-9.4c0 .2.2.4.4.4s.4-.1.4-.4c0-.2-.1-.4-.4-.4-.2 0-.4.2-.4.4zm.7-9.3c0 .2.1.4.4.4.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4-.2-.1-.4.1-.4.3zm.6-9.4c0 .2.2.4.4.4s.4-.1.4-.4c0-.2-.1-.4-.4-.4-.2.1-.4.2-.4.4zm.7-9.3c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm-20.5 28.2c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2 0 .2 0 .4.2.5zm4.2-8.4c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2 0 .2 0 .4.2.5zm4.2-8.3c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.1 0 .3.2.5 0-.1 0-.1 0 0zm4.2-8.4c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.1 0 .3.2.5zm23 27.7c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.3-.2.2-.3.4-.2.6zm-3-8.9c.1.2.3.3.5.3.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1 0-.3.2-.2.4zm-2.9-8.9c.1.2.3.3.5.2.2-.1.3-.3.3-.5-.1-.2-.3-.3-.5-.2s-.4.3-.3.5zm-3-8.9c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.3-.2.2-.3.4-.2.6zm-34.8 19.8c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2 0 .4.1.5zm4.5-7.1c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5zm4.3-7.3c0 .1.1.2.1.2.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.1-.1-.2-.1-.3 0-.1 0-.1.1-.1.1-.2.1-.2.2-.1.3zm4.5-6.9c.2.1.4 0 .5-.1.1-.2 0-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2 0 .4.1.5zm21.3 26.9c.1.2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-1.9-8.2c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3c-.2.1-.3.2-.3.4zm-1.9-8.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-1.8-8.2c0 .2.2.3.4.2.2 0 .3-.2.3-.4s-.2-.3-.4-.3c-.3.2-.4.4-.3.5zm-1.9-8.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3c-.3 0-.4.2-.3.4zm-30.6 7c.1.2.3.2.5.1.1-.1.2-.3.1-.5s-.3-.2-.5-.1c-.1.1-.2.3-.1.5zM47.3 201c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm1.3-8.3c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.1 0-.3.1-.4.3zm1.4-8.2c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4s-.3.1-.4.3zm1.4-8.3c0 .2.1.4.3.4.1 0 .2 0 .3-.1 0-.1.1-.1.1-.2 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm27.2 18.1c.1.1.3.2.5.1s.2-.3.1-.5c-.1-.1-.3-.2-.5-.1s-.3.3-.1.5zm-4.9-6.8c.1.2.3.2.5.1s.2-.3.1-.5c-.1-.1-.3-.2-.5-.1s-.2.3-.1.5zm-42.5-9c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3zm19.4 7.1c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.2 0-.2.1-.2.2zm-.2-4.9c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.2-4.9c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.1-.1-.2 0-.2.2zm-9.2 5.7c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.2 0 .3.1.3zm1.7-4.6c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .1 0 .3.1.3zm17 4c0 .1.2.1.3.1.1 0 .1-.2.1-.3 0-.1-.1-.1-.2-.1-.2.1-.2.2-.2.3zm-2-4.5c0 .1.2.1.3.1.1 0 .1-.2.1-.3 0-.1-.1-.1-.2-.1-.2.1-.2.2-.2.3zm-30 7c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1-.1 0-.1.2.1.3zm3-4.8c.1.1.3 0 .3-.1s0-.3-.1-.3c-.1-.1-.2 0-.3.1-.1.1 0 .2.1.3zm20.2 8.8c0 .1.1.2.2.2s.2-.2.2-.3c0-.1-.2-.2-.3-.2-.1 0-.1.1-.1.3zm-1.2-5.5c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2 0-.3.2-.2.3zm-1.2-5.5c0 .1.1.2.2.2s.2-.2.2-.3c0-.1-.2-.2-.3-.2-.1 0-.2.1-.1.3zm-9.1 8.4c.2.1.3 0 .4-.1 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2-.1.1 0 .2.1.2zm.8-5.8c0 .1.1.2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2zm20.2 1.3c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.2 0-.2.2-.1.3zm-3.2-4.6c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.2 0-.2.2-.1.3zM32 198.5c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3 0-.5.1-.5.3zm1.5-9.5c0 .2.1.4.3.5.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.2-.4 0-.4.2zm1.5-9.5c0 .2.1.4.3.5s.4-.1.5-.3c0-.2-.1-.4-.3-.5-.3-.1-.5 0-.5.3zm35 19.3c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.1.2-.2.4-.1.6zm-5.6-7.8c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.2-.3.4-.1.6zm-5.7-7.8c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.2-.2.4-.1.6zm-5.7-7.8c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.5-.1-.3.2-.3.4-.2.6zm-29.8 5.5c.2.1.4.1.6-.1s.1-.4-.1-.6c-.2-.1-.4-.1-.6.1-.1.2 0 .4.1.6zm26.2 22.2c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.3-.3-.5-.3c-.2.1-.3.3-.3.5zm-2.2-9.4c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.3-.3-.5-.3c-.2.1-.4.3-.3.5zm-2.3-9.3c0 .2.3.3.5.3s.4-.3.3-.5c0-.2-.3-.4-.5-.3-.2 0-.3.2-.3.5 0-.1 0 0 0 0zm-1.3 21.8c0 .2.3.3.5.3s.3-.3.3-.5-.3-.3-.5-.3c-.2.1-.4.3-.3.5zm-1.9-9.4c0 .2.3.4.5.3.2 0 .3-.3.3-.5s-.3-.4-.5-.3c-.2.1-.3.3-.3.5zm-1.8-9.4c0 .2.3.4.5.3.2 0 .4-.2.3-.5 0-.2-.2-.4-.5-.3-.2 0-.4.2-.3.5zm-1.9-9.5c0 .2.2.4.4.3.2 0 .4-.2.3-.5 0-.2-.2-.4-.5-.3-.1.1-.2.3-.2.5zm23.5-4.6c.2.1.4.1.6-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.3.2-.2.4 0 .5zm-36 18.1c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3 0-.5.1-.5.3zm1.9-9.4c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5.1-.5.3zm32.4 12.3c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.3.1-.3.3-.2.5zm-5.3-8c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.3.1-.3.3-.2.5zm-5.4-8c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.6-.1s-.2.3-.1.5zm-5.3 11.3c.1.2.2.2.4.2.1-.1.2-.2.2-.4-.1-.1-.2-.2-.4-.2-.2.1-.3.3-.2.4zm-2.9-6.6c.1.2.2.2.4.2.2-.1.2-.2.2-.4-.1-.2-.2-.2-.4-.2-.1 0-.2.2-.2.4zm-2.8-6.7c.1.2.2.2.4.2.2-.1.2-.2.2-.4-.1-.2-.2-.2-.4-.2-.2.1-.3.3-.2.4zm-9.7 12.6c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.1-.3.3zm-.1-7.3c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.2-.3.3zm25.8-3.2c.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4zm-22.9.9c.1.1.3.2.4.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.3-.1-.2 0-.2.2-.2.3z",
                  },
                }),
                _c("path", {
                  staticClass: "st35",
                  attrs: {
                    id: "texture-4-i5",
                    d: "M73 176.4c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .3.1.3zm1.9-4.5c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .2.1.3zm18.7 4.5c0 .1.2.2.3.1.1 0 .1-.1.1-.2s-.2-.2-.3-.1c0-.1-.1.1-.1.2zm-10.4-.7c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm0-4.9c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zM46 177.6c.1.2.4.2.5 0 .2-.1.2-.4 0-.5-.1-.2-.4-.2-.5 0-.1.1-.1.4 0 .5zm28.1 23.5c0 .2.2.4.4.4s.4-.1.4-.3c0-.2-.2-.4-.4-.4-.2-.1-.3.1-.4.3zm.7-9.3c0 .2.2.4.4.4s.4-.1.4-.4c0-.2-.1-.4-.4-.4-.2 0-.4.1-.4.4zm.7-9.4c0 .2.1.4.4.4.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4-.2-.1-.4.1-.4.3zm.6-9.3c0 .2.2.4.4.4s.4-.1.4-.4c0-.2-.1-.4-.4-.4-.2 0-.4.2-.4.4zm-19.8 18.8c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2 0 .2.1.4.2.5zm4.2-8.3c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2 0 .1 0 .4.2.5zm4.2-8.4c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.1 0 .4.2.5zm27.2 19.3c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.3-.2.2-.3.4-.2.6zm-3-8.9c.1.2.3.3.5.3.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1 0-.2.2-.2.4zm-2.9-8.8c.1.2.3.3.5.2.2-.1.3-.3.3-.5-.1-.2-.3-.3-.5-.2s-.4.3-.3.5zm-37.8 10.8c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2 0 .4.1.5zm4.5-7.1c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5zm4.3-7.3c0 .1.1.2.1.2.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.1-.1-.2-.1-.3 0-.1 0-.1.1-.1.1-.2.1-.2.2-.1.3zm25.8 20c.1.2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-1.9-8.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-1.9-8.2c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-14.1 12.5c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm1.4-8.3c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.2-.4.3zm1.3-8.2c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4s-.3.1-.4.3zm28.6 9.8c.1.1.3.2.5.1s.2-.3.1-.5c-.1-.1-.3-.2-.5-.1s-.3.3-.1.5zm-4.9-6.8c.1.2.3.2.5.1s.2-.3.1-.5c-.1-.1-.3-.2-.5-.1s-.2.3-.1.5zM68.2 174c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.2 0-.2.1-.2.2zm-.2-4.9c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm.5 6.7c0 .1.1.2.2.2s.2-.2.2-.3c0-.1-.2-.2-.3-.2-.1.1-.1.2-.1.3zm-1.2-5.5c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2.1-.3.2-.2.3zM57 173.2c0 .1 0 .1 0 0 .2.1.3 0 .4-.1 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2-.1.1 0 .2.1.2zM49.6 187c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5 0-.5.3zm1.5-9.6c0 .2.1.4.3.5.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4 0-.4.2zm36.5 9.9c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.1.1-.2.4-.1.6zm-5.6-7.8c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.3.4-.1.6zm-5.7-7.8c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6zM67 191.6c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.3-.3-.5-.3-.3.2-.3.5zm-2.2-9.4c.1.2.3.3.5.3.2-.1.3-.3.3-.5s-.3-.3-.5-.3-.4.3-.3.5zm-2.3-9.4c0 .2.3.3.5.3s.4-.3.3-.5c0-.2-.3-.4-.5-.3-.2 0-.3.3-.3.5zm-1.3 21.9c0 .2.3.3.5.3s.3-.3.3-.5-.3-.3-.5-.3-.3.2-.3.5zm-1.9-9.5c0 .2.3.4.5.3.2 0 .3-.3.3-.5s-.3-.4-.5-.3c-.2.1-.3.3-.3.5zm-1.8-9.4c0 .2.3.4.5.3.2 0 .4-.2.3-.5 0-.2-.2-.4-.5-.3-.2.1-.4.3-.3.5zm-14.4 4.1c0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5-.3-.1-.5.1-.5.3zm34.3 2.9c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.3 0-.3.3-.2.5zm-5.3-8c.1.2.4.2.6.1.2-.1.2-.4.1-.5-.1-.2-.4-.2-.5-.1-.3 0-.3.3-.2.5zm-10.7 3.3c.1.2.2.2.4.2.1-.1.2-.2.2-.4-.1-.1-.2-.2-.4-.2s-.3.2-.2.4zm-15.4-.8c0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.1 0-.3.2-.3.3z",
                  },
                }),
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    id: "L_sleeve-i5",
                    d: "M141.9 131.4s-3.5 7.1-15.5 7.6c-12.1.5-14.8 2.5-23.7 8.1-8.9 5.7-25.6 7.9-42.4-18.2-15.4-24-20.6-50.5-17.9-64.6 4.1 1.5 8.3 2.7 12.6 3.6 1.4.3 2.7.5 3.9.7 2.2.3 6.6.6 8.2.6 2.9 9.4 6.2 45.1 27.6 40.8 13.4-2.6 26.4-7 38.6-13.2l8.6 34.6z",
                  },
                }),
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    id: "sweater-i5",
                    d: "M69.2 167.8c-10.4 4.6-25 8.3-45.5 9.2-4.8.2-9.9.2-15.4.1-16.7-19.5-4-40.6.8-54.1s.2-14 9.2-37c1-2.4 2.1-4.7 3.4-6.9 1.5 21.7 10 46.1 21.9 66.8 7.5 12.9 15.9 19.7 25.6 21.9z",
                  },
                }),
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    id: "R_sleeve-i5",
                    d: "M146.7 140.7s-3.9 11.4-23.4 14.5c-19.4 3.1-23.1 8.8-32.7 11.4-7.8 2.1-14.9 2.7-21.4 1.2-9.7-2.2-18.1-9-25.5-21.8-11.8-20.7-20.4-45.1-21.9-66.8 2.4-4.3 5.1-8.3 8.1-12.2 3.2-3.9 5.8-6.8 7.9-9 2.8-1.4 24.7-5.2 28.2-4.6 0 0-1.4 32.2 14.1 52.8 1.7 2.2-1.3-1.9 0 0 6.1 9 11.6 10.2 16.8 10.2 6 0 26.8-5.6 38-15.6l11.8 39.9z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#ffbeb6" },
                  attrs: {
                    id: "face-i5",
                    d: "M57.4 45.8c4.5 3.9 14.8 10.4 21 7.9 7.4-3 9.5-9.1 10.9-8.9 1.4.2 4.4 0 4.8-1.4.4-1.4-2.3-6.4-1.6-11.8.1-.5.1-1 .1-1.5v-.8c0-.6 0-1.4-.1-2.4 0-.5-.1-1-.2-1.5-.1-.6-.2-1.3-.4-1.9v-.1c0-.2-.1-.3-.1-.5l-.3-.9c-.1-.2-.2-.5-.2-.7 0-.1-.1-.2-.1-.3l-.3-.6s0-.1-.1-.1c-.1.4-.3.8-.4 1.2-.1.1-.1.3-.2.4l-.9 1.5c-.1.1-.1.2-.2.2-.1.1-.1.2-.2.2-.1.2-.3.3-.4.5l-.1.1c-.2.3-.5.5-.7.7l-.3.3c-.2.2-.4.3-.6.5-.1.1-.2.2-.3.2-.5.4-1 .7-1.5 1l-.6.3c-.1.1-.2.1-.3.2-.1.1-.2.1-.3.2-.1 0-.1.1-.2.1-.2.1-.3.2-.5.2-.2.1-.3.2-.5.2-.2.1-.3.2-.5.2-.5.2-1 .4-1.5.5l-.9.3c-1.1.3-2.3.6-3.5.8l-.8.1c-2.3.4-4.6 1.1-6.8 2.1-.3.2-.6.4-1 .6-.9.5-1.8 1.1-2.6 1.8-3.3 3.1-6 6.9-7.6 11.1z",
                  },
                }),
                _c("path", {
                  staticClass: "st18",
                  attrs: {
                    id: "eye-i5",
                    d: "M95 33c-1 1.6-3.2 2-4.7 1-.6-.4-1-.9-1.3-1.5-.2-.5.5-.9.7-.4.5 1.3 2 2 3.3 1.5.5-.2.9-.5 1.2-1 .4-.5 1.1-.1.8.4z",
                  },
                }),
                _c("path", {
                  staticClass: "st21",
                  attrs: {
                    id: "hair-i5",
                    d: "M71.5.9c-2.6-.7-5.2-1-7.9-.8h-.1c-9.7.3-17.1 5.8-21.7 13.5-2.6 4-4.6 8.4-5.7 13-2.4 8.4-4.8 24.3-16.3 23.9-.5 0-.5.8 0 .8 7.4.3 11.1-6.1 13.5-12.3 1.6-4.1 2.6-8.3 3.8-12.4-.3 1.7-.5 3.5-.7 5.2-1.3 18.7-14.9 21.9-14.9 21.9 6.4 4.3 13.3 7.8 20.6 10.5 4.2 1.6 8.5 2.8 12.9 3.7 1.4.3 2.7.5 3.9.7 3.5.6 7.2.8 10.7.6 5.8-7.7 3.7-15.5 1.2-22 3.7 7 5.6 13.5 1.7 21.3-.2.5.5.9.7.4 2.3-4.4 3-9.5 1.8-14.4-1.6-6.6-7.6-11.9-7.1-18.8.5-1.8 2.1-3.1 5.6-3.8.2 0 .3-.1.5-.1C91.3 28.9 90.9 20 90.9 20c1.3 3.2 1.9 6.6 1.7 10C99.2 13.3 84.3 4.6 71.5.9z",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }